import React, { useEffect, useState } from "react"
import { Col, Form, Row, Button, Table, Tab, Tabs } from "react-bootstrap"
import toast from "react-hot-toast"
import {
  formatDate,
  isAdmin,
  numberFormat,
  selectDropdownStyle,
  toastStyle,
} from "../../Helpers/Utils/Common"
import Select from "react-select"
import trash from "../../Assets/Images/trash.png"
import { SyncLoader } from "react-spinners"

//components
import TableTemplate from "../../Components/TableTemplate/DataTable"
import Navbar from "../../Components/Navbar/Navbar"
import DeleteModal from "../../Components/Modals/DeleteModal"
import AddModal from "../../Components/Modals/AddModal"
import EditModal from "../../Components/Modals/EditModal"
import ViewModal from "../../Components/Modals/ViewModal"
import InputError from "../../Components/InputError/InputError"
import downloadIcon from "../../Assets/Images/download_icon.png"
import * as XLSX from "xlsx"

//css
import "./Manage.css"
import "../../Components/Navbar/Navbar.css"
import equal from "../../Assets/Images/equal.png"

//api
import {
  createItem,
  getItem,
  deleteItem,
  searchItem,
  editItem,
} from "../../Helpers/apiCalls/itemsApi"
import { getUser, refreshPage } from "../../Helpers/Utils/Common"
import { useNavigate } from "react-router-dom"
import { Typeahead } from "react-bootstrap-typeahead"
import { getCategory, getSubcategory } from "../../Helpers/apiCalls/categoryApi"
import { getBrand } from "../../Helpers/apiCalls/brandsApi"
import { validateItems } from "../../Helpers/Validation/Manage/ItemsValidation"
import { getAllPriceLevels } from "../../Helpers/apiCalls/Manage/PriceLevels"
import { createItemPrice } from "../../Helpers/apiCalls/Manage/ItemPrice"
import Footer from "../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination"

export default function Items() {
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [showEditLoader, setShowEditLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [priceLevelDetails, setPriceLevelDetails] = useState([[]])
  const [priceLevel, setPriceLevels] = useState([])
  const [filteredPriceLevel, setFilteredPriceLevels] = useState([])

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  // VIEW
  const [showViewItemModal, setShowViewItemModal] = useState(false)
  const handleShowViewItemModal = () => setShowViewItemModal(true)
  const handleCloseViewItemModal = () => setShowViewItemModal(false)

  // EDIT
  const [showEditItemModal, setShowEditItemModal] = useState(false)
  const handleShowEditItemModal = () => setShowEditItemModal(true)
  const handleCloseEditItemModal = () => setShowEditItemModal(false)

  // EDIT Conversion
  const [showEditConversionModal, setShowEditConversionModal] = useState(false)
  const handleShowEditConversionModal = () => setShowEditConversionModal(true)
  const handleCloseEditConversionModal = () => setShowEditConversionModal(false)

  // ADD
  const [showAddItemModal, setShowAddItemModal] = useState(false)
  const handleShowAddItemModal = () => setShowAddItemModal(true)
  const handleCloseAddItemModal = () => setShowAddItemModal(false)

  // ADD PRICE
  const [showAddItemPriceModal, setShowAddItemPriceModal] = useState(false)
  const handleShowAddItemPriceModal = () => setShowAddItemPriceModal(true)
  const handleCloseAddItemPriceModal = () => {
    refreshPage()
    setShowAddItemPriceModal(false)
  }

  // ADD Conversion
  const [showAddConversionModal, setShowAddConversionModal] = useState(false)
  const handleShowAddConversionModal = () => setShowAddConversionModal(true)
  const handleCloseAddConversionModal = () => setShowAddConversionModal(false)

  //API
  const [allData, setAllData] = useState([])
  const [itemData, setItemData] = useState({})
  const [selectedRow, setSelectedRow] = useState([])
  const [selectedID, setSelectedID] = useState("")
  const [categories, setCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [brand, setBrand] = useState([])
  const [excelData, setExcelData] = useState([])
  const [selectedSubcategoryCount, setselectedSubcategoryCount] = useState([])
  const [itemDetails, setItemDetails] = useState({
    name: "",
    type: "",
    detail: "",
    added_by: getUser(),
    added_on: formatDate(),
    category: [{ value: "" }],
    category_options: [{ value: "" }],
  })

  const [itemsUnits, setItemsUnits] = useState([
    {
      unit_from: "",
      value_from: "",
      unit_to: "",
      value_to: "",
      minimum: "",
      maximum: "",
      acceptable_variance: "",
    },
  ])

  const [itemsUnitsMap, setItemsUnitsMap] = useState([
    {
      unit_from: "",
      value_from: "",
      unit_to: "",
      value_to: "",
      minimum: "",
      maximum: "",
      acceptable_variance: "",
    },
  ])

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    name: false,
    inhouse_barcode: false,
    category: false,
    sales_type: false,
  })

  const [filterConfig, setFilterConfig] = useState({
    name: "",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  const xlsxHeaders = [
    // "BARCODE",
    // "INHOUSE BARCODE",
    // "SERIAL NO.",
    "ITEM DESCRIPTION",
    "CATEGORY",
    "SUB-CATEGORY",
    "TAG",
    "SALES TYPE",
  ]

  //ONCHANGE
  //ADD or CREATE ITEM
  const handleAddChange = (e) => {
    const { name, value } = e.target

    if (name === "is_for_sale") {
      if (itemDetails.is_for_sale === 1) {
        setItemDetails((prevState) => ({
          ...prevState,
          [name]: 0,
        }))
      } else {
        setItemDetails((prevState) => ({
          ...prevState,
          [name]: 1,
        }))
      }
    } else if (name === "is_dsr") {
      if (itemDetails.is_dsr === 1) {
        setItemDetails((prevState) => ({
          ...prevState,
          [name]: 0,
        }))
      } else {
        setItemDetails((prevState) => ({
          ...prevState,
          [name]: 1,
        }))
      }
    } else {
      setItemDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }
  // SELECT DROPDOWN CHANGE
  const handleSelectDropdownChange = (e, action, index) => {
    if (action === "add") {
      if (e.name === "category" || e.name === "subcategory") {
        // if category/subcategory ma save siya sud sa categories array
        var categories = [...itemDetails.category]
        // para if mo select siya ug another subcategory ma reset iya child
        if (
          categories[index]?.value
            ? categories[index]?.value !== e.value
            : false
        ) {
          categories.splice(index)
        }
        // para ma set ang value sa selected category
        categories[index] = { value: e.value, label: e.label }
        fetchSubcategories(e.id, categories, "add", index)
        setItemDetails({
          ...itemDetails,
          ["category"]: categories,
          [`${e.name}_id`]: e.id,
        })
      } else {
        setItemDetails({
          ...itemDetails,
          [e.name]: e.value,
          [`${e.name}_id`]: e.id,
        })
      }
    } else {
      if (e.name === "category" || e.name === "subcategory") {
        // if category/subcategory ma save siya sud sa categories array
        var categories = [...itemData.category]
        // para if mo select siya ug another subcategory ma reset iya child
        if (
          categories[index]?.value
            ? categories[index]?.value !== e.value
            : false
        ) {
          categories.splice(index)
        }
        // para ma set ang value sa selected category
        categories[index] = { value: e.value, label: e.label }
        fetchSubcategories(e.id, categories, "edit", index)
        setItemData({
          ...itemData,
          ["category"]: categories,
          [`${e.name}_id`]: e.id,
        })
      } else {
        setItemData({
          ...itemData,
          [e.name]: e.value,
        })
      }
    }
  }

  //EDIT or UPDATE ITEM
  const handleEditChange = (e) => {
    const { name, value } = e.target

    if (name === "is_for_sale") {
      if (value === "true") {
        setItemData((prevState) => ({
          ...prevState,
          [name]: false,
        }))
      } else if (value === "false") {
        setItemData((prevState) => ({
          ...prevState,
          [name]: true,
        }))
      } else {
      }
    } else if (name === "is_dsr") {
      if (value === "true") {
        setItemData((prevState) => ({
          ...prevState,
          [name]: false,
        }))
      } else if (value === "false") {
        setItemData((prevState) => ({
          ...prevState,
          [name]: true,
        }))
      } else {
      }
    } else {
      setItemData((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }

  // SEARCH USER
  function handleOnSearch(e) {
    setCurrentPage(1)
    setFilterConfig((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
        page: 1,
      }
    })
  }

  //DELETE or REMOVE ITEM
  function handleDeleteItem() {
    removeItem(selectedID)
  }

  function handleFilterChange(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value, page: 1 }
    })
    setCurrentPage(1)
  }

  function AddItemEdit() {
    const newItem = {
      value_from: "",
      unit_from: "",
      value_to: "",
      unit_to: "",
      minimum: "",
      maximum: "",
      acceptable_variance: "",
    }
    setItemsUnitsMap((prevItemsUnitsMap) => [...prevItemsUnitsMap, newItem])
  }
  //HANDLE
  function handleItemChange(e, id) {
    const { name, value } = e.target
    var newItemsUnits = itemsUnits
    if (name === "unit_from") {
      var newBreakdownUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownUnit)
    } else if (name === "value_from") {
      var newBreakdownValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownValue)
    } else if (name === "unit_to") {
      var newInventoryUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_to = value
        }
        return item
      })
      setItemsUnits(newInventoryUnit)
    } else if (name === "value_to") {
      var newInventoryValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_to = value
        }
        return item
      })
      setItemsUnits(newInventoryValue)
    } else if (name === "minimum") {
      var newMinimum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.minimum = value
        }
        return item
      })
      setItemsUnits(newMinimum)
    } else if (name === "maximum") {
      var newMaximum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.maximum = value
        }
        return item
      })
      setItemsUnits(newMaximum)
    } else if (name === "acceptable_variance") {
      var newAcceptableVatriance = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.acceptable_variance = value
        }
        return item
      })
      setItemsUnits(newAcceptableVatriance)
    }
  }

  function handleExport() {
    const rows = excelData

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "Items.xlsx", { compression: true })
  }

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  function handleItemChangeEdit(e, id) {
    const { name, value } = e.target
    var newItemsUnitsMap = itemsUnitsMap
    if (name === "unit_from") {
      var newBreakdownUnit = newItemsUnitsMap.map((item, index) => {
        if (index === id) {
          item.unit_from = value
        }
        return item
      })
      setItemsUnitsMap(newBreakdownUnit)
    } else if (name === "value_from") {
      var newBreakdownValue = newItemsUnitsMap.map((item, index) => {
        if (index === id) {
          item.value_from = value
        }
        return item
      })
      setItemsUnitsMap(newBreakdownValue)
    } else if (name === "unit_to") {
      var newInventoryUnit = newItemsUnitsMap.map((item, index) => {
        if (index === id) {
          item.unit_to = value
        }
        return item
      })
      setItemsUnitsMap(newInventoryUnit)
    } else if (name === "value_to") {
      var newInventoryValue = newItemsUnitsMap.map((item, index) => {
        if (index === id) {
          item.value_to = value
        }
        return item
      })
      setItemsUnitsMap(newInventoryValue)
    } else if (name === "minimum") {
      var newMinimum = newItemsUnitsMap.map((item, index) => {
        if (index === id) {
          item.minimum = value
        }
        return item
      })
      setItemsUnitsMap(newMinimum)
    } else if (name === "maximum") {
      var newMaximum = newItemsUnitsMap.map((item, index) => {
        if (index === id) {
          item.maximum = value
        }
        return item
      })
      setItemsUnitsMap(newMaximum)
    } else if (name === "acceptable_variance") {
      var newAcceptableVatriance = newItemsUnitsMap.map((item, index) => {
        if (index === id) {
          item.acceptable_variance = value
        }
        return item
      })
      setItemsUnitsMap(newAcceptableVatriance)
    }
  }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>
              VALUE 1 - Warehouse Unit<span className="required">*</span>
            </th>
            <th> </th>
            <th>
              VALUE 2 - Store Unit<span className="required">*</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {itemsUnits.map((item, index) => {
            return (
              <tr>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleItemChange(e, index)}
                      // disabled
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleItemChange(e, index)}
                      // disabled
                    />
                  </Col>
                </td>

                <td>
                  <img src={equal} className="cursor-pointer" alt="equal to" />
                </td>

                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_from"
                      className="nc-modal-custom-input hide-spinner numeric-input"
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_from"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </Col>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function editTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>
              VALUE 1 - Warehouse Unit<span className="required">*</span>
            </th>
            <th> </th>
            <th>
              VALUE 2 - Store Unit<span className="required">*</span>
            </th>
            {/* <th>Actions</th> */}
          </tr>
        </thead>
        <tbody>
          {itemsUnitsMap?.map((data, index) => {
            return (
              <tr key={index}>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_to"
                      className="nc-modal-custom-input"
                      defaultValue={data.value_to}
                      onChange={(e) => handleItemChangeEdit(e, index)}
                      disabled
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_to"
                      className="nc-modal-custom-input"
                      defaultValue={data.unit_to}
                      onChange={(e) => handleItemChangeEdit(e, index)}
                      disabled
                    />
                  </Col>
                </td>
                <td>
                  <img src={equal} className="cursor-pointer" alt="equal to" />
                </td>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_from"
                      className="nc-modal-custom-input hide-spinner numeric-input"
                      defaultValue={data.value_from}
                      onChange={(e) => handleItemChangeEdit(e, index)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_from"
                      className="nc-modal-custom-input"
                      defaultValue={data.unit_from}
                      onChange={(e) => handleItemChangeEdit(e, index)}
                    />
                  </Col>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function viewTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th> VALUE 1 - Warehouse Unit </th>
            <th> </th>
            <th> VALUE 2 - Store Unit </th>
          </tr>
        </thead>
        <tbody>
          {itemsUnitsMap.map((data, index) => {
            return (
              <tr key={index}>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_to"
                      className="nc-modal-custom-input"
                      value={data.value_to}
                      disabled
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_to"
                      className="nc-modal-custom-input"
                      defaultValue={data.unit_to}
                      disabled
                    />
                  </Col>
                </td>
                <td>
                  <img src={equal} className="cursor-pointer" alt="equal to" />
                </td>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_from"
                      className="nc-modal-custom-input hide-spinner numeric-input"
                      value={data.value_from}
                      disabled
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_from"
                      className="nc-modal-custom-input"
                      defaultValue={data.unit_from}
                      disabled
                    />
                  </Col>
                </td>
              </tr>
            )
            // })}
          })}
        </tbody>
      </Table>
    )
  }

  // DROPDOWN SELECT
  function handleSelectChange(e, row) {
    setSelectedRow(row)
    setItemsUnitsMap([])
    setSelectedID(row.id)

    if (e.target.value === "delete-item") {
      handleShowDeleteModal()
    } else if (e.target.value === "edit-item") {
      fetchItem(row.id, "edit")
      // setItemData(row)
      // setItemsUnitsMap(row.item_units); //commented sa for now kay wala pay api to be updated on new async function
      handleShowEditItemModal()
    } else if (e.target.value === "view-item") {
      fetchItem(row.id, "view")
      // setItemData(row)
      // setItemsUnitsMap(row.item_units); //commented sa for now kay wala pay api to be updated on new async function
      handleShowViewItemModal()
    } else if (e.target.value === "item-details") {
      navigate("/itemlists/itemdetails/" + row.id)
    } else if (e.target.value === "view-prices") {
      navigate("/itemprices", {
        state: { name: row.item_name },
      })
    } else {
      refreshPage()
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-item" className="color-options">
          View
        </option>
        <option value="item-details" className="color-options">
          Item Details
        </option>
        <option value="view-prices" className="color-options">
          View Prices
        </option>
        {isAdmin && (
          <option value="edit-item" className="color-options">
            Edit
          </option>
        )}
        {isAdmin && (
          <option value="delete-item" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  //API CALL
  async function fetchAllItems() {
    setTotalItems(0)
    setExcelData([])
    setAllData([])
    setShowLoader(true)
    const response = await searchItem(filterConfig)
    if (response.response) {
      var itemsList = response.response.data.map((data) => {
        var info = data
        info.item_name = data.name
        info.item_description = data.name
        info.name = data.base
        info.category_sub = data.category_list

        // info.category = data?.category?.map((category) => {
        //   var info = category
        //   info.label= category.name
        //   info.value= category.name
        //   return info
        // })
        // info.category_options = data?.category_options?.map((options) => {
        //   var options = options.map((data) => {
        //     var info = data
        //     info.label= data.name
        //     info.value= data.name
        //     return info
        //   })
        //   return options
        // })
        // if(data.brand_id) { //SETTING BRAND TYPEAHEAD VALUE
        //   info.selected_brand = [{
        //     id: data.brand_id,
        //     customOption: false,
        //     value: data.brand_name,
        //   }]
        // }

        return info
      })
      setAllData(itemsList)
      setTotalItems(response.response.size)

      var excel = itemsList.map((bill) => {
        var info = {}
        info.item_code = bill.item_code
        info.brand_name = bill.brand_name
        info.barcode = bill.barcode
        info.inhouse_barcode = bill.inhouse_barcode
        info.serial_number = bill.serial_number
        info.item_description = bill.item_description
        info.category = bill.category
        info.subcategory = bill.subcategory
        info.tag = bill.tag
        info.sales_type = bill.sales_type
        return info
      })
      setExcelData(excel)
    }
    setShowLoader(false)
  }

  async function fetchItem(id, type) {
    setShowEditLoader(true)
    const response = await getItem(id)
    if (response.data) {
      var data = response.data[0]
      data.item_name = data.name
      data.category = data?.category?.map((category) => {
        var info = category
        info.label = category.name
        info.value = category.name
        return info
      })
      data.category_options = data?.category_options?.map((options) => {
        var options = options.map((data) => {
          var info = data
          info.label = data.name
          info.value = data.name
          return info
        })
        return options
      })
      if (data.brand_id) {
        //SETTING BRAND TYPEAHEAD VALUE
        data.selected_brand = [
          {
            id: data.brand_id,
            customOption: false,
            value: data.brand_name,
          },
        ]
      } else {
        data.selected_brand = []
      }

      // to set the first array to the item units of the selected item
      const newList = [...priceLevelDetails]
      var units = data.item_units.map((data) => {
        var info = data
        info.original_cost_price = data.cost_price
        return info
      })
      newList[priceLevelDetails.length - 1] = units
      setPriceLevelDetails(newList)
      if (type === "conversion") {
        //if conversion ang gi pass na type, mo show ang conversion modal
        handleShowAddItemPriceModal()
        handleCloseAddConversionModal()
      }

      setItemsUnitsMap(data.item_units)
      setItemData(data)
      // if (data.item_units === false) {
      //   response.data.map(
      //     (data) => (data.item_units = data.item_units || [])
      //   );
      //   setItemsUnitsMap([]);
      //   setItemData(data);
      // } else {
      //   setItemsUnitsMap(data.item_units);
      //   setItemData(data);
      // }
    } else {
      setItemData({})
    }
    setShowEditLoader(false)
  }

  async function handleSaveItem() {
    // var hasUnits = itemsUnits.length > 0 ? true : false;
    if (validateItems(itemDetails, setIsError)) {
      setIsClicked(true)
      const response = await createItem(itemDetails, itemsUnits)
      if (response.response) {
        setItemDetails((prevState) => ({
          ...prevState,
          id: response.response.item_id,
        }))
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        handleCloseAddItemModal()
        handleShowAddConversionModal()
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
  }

  async function handleAddConversion() {
    setIsClicked(true)

    const response = await editItem(itemDetails, itemsUnits)
    if (response.response) {
      var details = { ...itemDetails }
      details.item_id = response.response.item_id
      details.item_unit_id = response.response.item_unit_id
      details.unit = response.response.unit
      details.unit_from = itemsUnits.unit_from
      details.unit_to = itemsUnits.unit_to
      setItemDetails(details)
      fetchItem(response.response.item_id, "conversion")
      toast.success(response.response.message, {
        style: toastStyle(),
      })
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  // FUNCTION TO SAVE ITEM PRICE
  async function handleSaveItemPrice() {
    setIsClicked(true)
    const response = await createItemPrice(itemDetails, priceLevelDetails)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => {
        refreshPage()
      }, 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  async function handleEditItem() {
    if (validateItems(itemData, setIsError)) {
      setIsClicked(true)
      const response = await editItem(itemData, itemsUnitsMap)

      if (response.response) {
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        setTimeout(() => {
          refreshPage()
        }, 500)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
    setIsClicked(false)
  }

  async function handleEditConversion() {
    setIsClicked(true)
    const response = await editItem(itemData, itemsUnitsMap)
    if (response.response) {
      setTimeout(() => {
        toast.success("Successfully edited conversion!", {
          style: toastStyle(),
        })
        handleCloseEditConversionModal()
        refreshPage()
      }, 3000)
    } else {
      toast.error("Error updating item!", {
        style: toastStyle(),
      })
    }
  }

  async function removeItem(id) {
    setIsClicked(true)
    const response = await deleteItem(id)
    if (response.data) {
      toast.success("Successfully deleted item!", {
        style: toastStyle(),
      })
      handleCloseDeleteModal()
      fetchAllItems()
      refreshPage()
    } else {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      })
      refreshPage()
    }
  }

  const handleTypeaheadChange = (e, labelKey, action) => {
    if (action === "add") {
      if (e[0] !== undefined) {
        if (e[0].customOption) {
          setItemDetails((prevState) => ({
            ...prevState,
            [labelKey]: e[0].value,
            [`${labelKey}_id`]: "",
            [`selected_${labelKey}`]: [e[0]],
          }))
        } else {
          setItemDetails((prevState) => ({
            ...prevState,
            [e[0].name]: e[0].value,
            [`${labelKey}_id`]: e[0].id,
            [`selected_${labelKey}`]: [e[0]],
          }))
        }
      } else if (e === undefined || e === null || e.length === 0) {
        setItemDetails((prevState) => ({
          ...prevState,
          [labelKey]: "",
          [`${labelKey}_id`]: "",
          [`selected_${labelKey}`]: [],
        }))
      }
    } else {
      if (e[0] !== undefined) {
        if (e[0].customOption) {
          setItemData((prevState) => ({
            ...prevState,
            [labelKey]: e[0].value,
            [`${labelKey}_id`]: "",
            [`selected_${labelKey}`]: [e[0]],
          }))
        } else {
          setItemData((prevState) => ({
            ...prevState,
            [e[0].name]: e[0].value,
            [`${labelKey}_id`]: e[0].id,
            [`selected_${labelKey}`]: [e[0]],
          }))
        }
      } else if (e === undefined || e === null || e.length === 0) {
        setItemData((prevState) => ({
          ...prevState,
          [labelKey]: "",
          [`${labelKey}_id`]: "",
          [`selected_${labelKey}`]: [],
        }))
      }
    }
  }

  // Function to remove an input field
  const handleRemoveSubcategory = (index, type) => {
    var categories = []
    if (type === "add") {
      categories = itemDetails.category
    } else {
      categories = itemData.category
    }
    const newInputs = [...categories]
    newInputs.splice(index) // Remove the input at the specified index
    setItemDetails({
      // Update the state with the new array
      ...itemDetails,
      ["category"]: newInputs,
    })
  }

  // ADD PRICE LEVEL HANDLER
  function handleAddPriceLevel() {
    var newList = []
    var units = itemData.item_units.map((data) => {
      var info = data
      info.original_cost_price = data.cost_price
      return info
    })
    newList = units

    setPriceLevelDetails((oldItems) => [...oldItems, newList])
  }

  // PRICE LEVEL REMOVAL HANDLER
  function handleRemovePriceLevel(id) {
    const rowId = id
    const newItemList = [...priceLevelDetails]
    newItemList.splice(rowId, 1)
    setPriceLevelDetails(newItemList)

    // to filter price level and remove the selected ones in the option
    const flattenedNewList = newItemList.flat() // Flatten the nested arrays
    const filteredOptions = priceLevel.filter((option) => {
      // Check if any object in flattenedNewList has the same price_level_id
      return !flattenedNewList.some(
        (item) => item.price_level_id === option.value
      )
    })

    setFilteredPriceLevels(filteredOptions)
  }

  // updated price level details change
  const handlePriceLevelChange = (e, type, level_index, unit_index) => {
    if (type === "price_level") {
      const { name, value, label } = e
      const newList = [...priceLevelDetails]

      const updatedList = newList.map((subArray, index) => {
        if (index === level_index) {
          // If the current subArray index matches the level_index, update its elements
          return subArray.map((item) => ({
            ...item,
            price_level_id: value,
            price_level_id_value: {
              label: label,
              value: value,
            },
          }))
        }
        return subArray // If not the targeted index, return the subArray unchanged
      })
      // to set select dropdown value
      updatedList[level_index]["price_level_id_value"] = {
        label: label,
        value: value,
      }
      setPriceLevelDetails(updatedList)

      // to filter price level and remove the selected ones in the option
      const flattenedNewList = updatedList.flat() // Flatten the nested arrays
      const filteredOptions = priceLevel.filter((option) => {
        // Check if any object in flattenedNewList has the same price_level_id
        return !flattenedNewList.some(
          (item) => item.price_level_id === option.value
        )
      })

      setFilteredPriceLevels(filteredOptions)
    } else {
      const { name, value } = e.target

      const newList = [...priceLevelDetails]
      newList[level_index][unit_index][name] = value

      if (name === "margin") {
        var margin = value !== "" ? value : 0
        var cost_price = newList[level_index][unit_index]["cost_price"]
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["margin"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      } else if (name === "cost_price") {
        var margin = newList[level_index][unit_index]["margin"]
          ? newList[level_index][unit_index]["margin"]
          : 0
        var cost_price = value !== "" ? value : 0
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["cost_price"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      }
      setPriceLevelDetails(newList)
    }
  }
  // PRICE LEVEL DETAILS CHANGE HANDLER
  function handlePriceLevelDetailChange(
    e,
    price_level_index,
    type,
    price_key,
    price_level_data
  ) {
    if (type === "dropdown") {
      if (e.var_name === "price_level_id") {
        var newItemList = [...priceLevelDetails]
        newItemList[price_level_index]["price_level_id"] = e.value
        newItemList[price_level_index][e.for] = {
          name: e.name,
          label: e.label,
          value: e.value,
        }
        setPriceLevelDetails(newItemList)
      } else {
        const { name, value } = e.target
        var new_price_level = [...priceLevelDetails]
        var new_item_details = [...itemData.item_units]

        if (
          !Array.isArray(new_price_level[price_level_index]["unit"]) &&
          new_price_level[price_level_index]["unit"] === undefined
        ) {
          new_price_level[price_level_index]["unit"] = []
        }

        new_item_details?.forEach((item, index) => {
          if (index === parseInt(price_key)) {
            if (
              !new_price_level[price_level_index].unit[index] &&
              new_price_level[price_level_index].unit[index] === undefined
            ) {
              new_price_level[price_level_index]["unit"][index] = []
            }

            if (!new_price_level[price_level_index].unit[index].items) {
              new_price_level[price_level_index].unit[index].items = {}
            }

            if (
              new_price_level[price_level_index].unit[index].items === null ||
              new_price_level[price_level_index].unit[index].items === undefined
            ) {
              var items = {
                item_id: item.item_id,
                item_unit_id: item.id,
                unit: item.unit_from,
              }
              new_price_level[price_level_index].unit[index].items = items
            } else {
              // If the items object already exists, update its properties
              new_price_level[price_level_index].unit[index].items.item_id =
                item.item_id
              new_price_level[price_level_index].unit[
                index
              ].items.item_unit_id = item.id
              new_price_level[price_level_index].unit[index].items.unit =
                item.unit_from
            }
            new_price_level[price_level_index].unit[index][name] = value
            new_price_level[price_level_index].unit[index]["cost"] = item.cost
              ? item.cost
              : "0"
            if (name === "retail_price") {
              var vatEx = parseFloat(value) / 1.12
              var vatComponent = parseFloat(value) - vatEx
              new_price_level[price_level_index].unit[index].vat_in = value
              new_price_level[price_level_index].unit[index].vat_ex = vatEx
              new_price_level[price_level_index].unit[index].vat_component =
                vatComponent
            } else if (name === "margin_percentage") {
              var cost = new_price_level[price_level_index].unit[index].cost
              var margin = value !== "" ? value : 0
              var percentage =
                (parseFloat(cost) * parseFloat(margin)) / 100 +
                +parseFloat(cost)
              new_price_level[price_level_index].unit[index].margin_percentage =
                value
              new_price_level[price_level_index].unit[index].selling_price =
                percentage
              new_price_level[price_level_index].unit[index].wholesale_price =
                percentage
              new_price_level[price_level_index].unit[index].retail_price =
                percentage

              // VAT calculations
              var vatEx = parseFloat(percentage) / 1.12
              var vatComponent = parseFloat(percentage) - vatEx
              new_price_level[price_level_index].unit[index].vat_in = percentage
              new_price_level[price_level_index].unit[index].vat_ex = vatEx
              new_price_level[price_level_index].unit[index].vat_component =
                vatComponent
            }
          }
        })

        // Assuming you want to update the state with the modified priceLevelDetails
        setPriceLevelDetails(new_price_level)
      }
    } else {
      const { name, value } = e.target
      var items = [...priceLevelDetails]
      items[price_level_index][name] = value
      setPriceLevelDetails(items)
    }
  }

  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.name = "category"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
      //subcategories
      // var subcategories = response.data.subcategories.map((category) => {
      //   var info = {}
      //   info.name = "subcategory"
      //   info.value = category.subname
      //   info.label = category.subname
      //   info.id = category.id
      //   info.category_id = category.category_id
      //   info.selected_value_name = "selected_subcategory"
      //   return info
      // })
      // setSubCategories(subcategories);
    }
  }

  async function fetchSubcategories(id, categories, type, index) {
    setSubCategories([])
    const response = await getSubcategory(id)
    if (response.data) {
      //subcategories
      var subcategories = response.data.data.map((category) => {
        var info = {}
        info.name = "subcategory"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)

      // to set categories and options
      if (type === "add") {
        const options = [...itemDetails.category_options] // Create a copy of the options array
        options[index + 1] = subcategories // Update the value at the specified index

        setItemDetails({
          ...itemDetails,
          ["category"]: [...categories, ""],
          ["category_options"]: [...options],
        })
      } else {
        const options = [...itemData.category_options] // Create a copy of the options array
        options[index + 1] = subcategories // Update the value at the specified index

        setItemData({
          ...itemData,
          ["category"]: [...categories, ""],
          ["category_options"]: [...options],
        })
      }
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
  }

  async function fetchBrands() {
    const response = await getBrand({})
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.name = "brand"
        info.value = brand.name
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands)
    }
  }
  async function fetchPriceLevel() {
    setPriceLevels([])
    const response = await getAllPriceLevels()
    if (response.data) {
      var price_levels = response.data.data.map((data) => {
        var info = {}
        info.var_name = "price_level_id"
        info.for = "price_level_id_value"
        info.label = data.name
        info.value = data.id
        return info
      })
      setPriceLevels(price_levels)
      setFilteredPriceLevels(price_levels)
    }
  }

  useEffect(() => {
    fetchCategories()
    fetchBrands()
    fetchPriceLevel()
  }, [])

  useEffect(() => {
    fetchAllItems()
  }, [filterConfig, currentPage])

  return (
    <div className="items">
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"MANAGE ITEM"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              ITEMS{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              className="search-bar"
              defaultValue=""
              placeholder="Search..."
              // onChange={(e) => handleOnSearch(e)}
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button
                className="add-btn"
                eventKey="MANGO MAGIC"
                onClick={handleShowAddItemModal}
              >
                Add
              </button>
            </div>
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={6} lg={3} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Category"
                styles={selectDropdownStyle}
                value={filterConfig.selected_category}
                options={[
                  { label: "All Categories", value: "" },
                  ...categories,
                ]}
                onChange={(e) => {
                  setCurrentPage(1)
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      category: e.value,
                      selected_category: {
                        value: e.value,
                        label: e.label,
                      },
                      page: 1,
                    }
                  })
                }}
              />
            </Col>
            <Col xs={6} lg={3} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Brand"
                styles={selectDropdownStyle}
                value={filterConfig.selected_brand}
                options={[{ label: "All Brands", value: "" }, ...brand]}
                onChange={(e) => {
                  setCurrentPage(1)
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      brand: e.value,
                      selected_brand: {
                        value: e.value,
                        label: e.label,
                      },
                      page: 1,
                    }
                  })
                }}
              />
            </Col>
            {/* <Col xs={6} lg={2} className="mb-2 mb-lg-0">
            <Form.Select
              name="has_barcode"
              value={filterConfig.has_barcode}
              className="date-filter force-width w-full"
              onChange={(e) => handleFilterChange(e)}
            >
              <option value="" selected>
                Barcode
              </option>
              <option value="yes">With Barcode</option>
              <option value="no">Without Barcode</option>
            </Form.Select>
            </Col> */}
            <Col xs={6} lg={2} className="mb-2 mb-lg-0">
              <Form.Select
                name="sales_type"
                value={filterConfig.sales_type}
                className="date-filter force-width w-full"
                onChange={(e) => handleFilterChange(e)}
              >
                <option value="" selected>
                  All Sales Type
                </option>
                <option value="retail">Retail</option>
                <option value="wholesale">Wholesale</option>
                <option value="universal">Both</option>
              </Form.Select>
            </Col>
          </Row>
          <div className="mb-2" />

          {/* table */}
          <TableWithDynamicPagination
            tableHeaders={[
              "BARCODE",
              // "SERIAL NO.",
              "ITEM CODE",
              "ITEM DESCRIPTION",
              "CATEGORY",
              "BRAND",
              // "TAG",
              "SALES TYPE",
              "ACTIONS",
            ]}
            headerSelector={[
              "barcode",
              // "serial_number",\
              "item_code",
              "item_description",
              "category_name",
              "brand_name",
              // // "subcategory",
              // "tag",
              "sales_type",
            ]}
            tableData={allData}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
            // used in dynamic pagination
            totalItems={totalItems}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handlePageChange={handlePageChange}
            className="items-page-table"
          />

          <div className="mb-2" />
        </div>
        <div className="mb-3" />
        <br />
        <Row>
          <Col lg={10}></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>

      {/* MODALS */}
      <DeleteModal
        text="item"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteItem}
        isClicked={isClicked}
      />
      <AddModal
        title={`ITEM`}
        type="item"
        show={showAddItemModal}
        onHide={handleCloseAddItemModal}
        onSave={handleSaveItem}
        isClicked={isClicked}
      >
        <div className=" mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DESCRIPTION
            </span>
            <Col xs={12} lg={4}>
              ITEM NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Item name is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              BRAND
              <Typeahead
                id="basic-typeahead-single"
                name="value"
                labelKey="value"
                allowNew
                className="nc-modal-custom-text"
                onChange={(e) => handleTypeaheadChange(e, "brand", "add")}
                options={brand}
                placeholder="Select/type a brand..."
                selected={itemDetails.selected_brand}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              MODEL
              {/* <span className="required"> * </span> */}
              <Form.Control
                type="text"
                name="model"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={4}>
              MATERIAL
              <Form.Control
                type="text"
                name="material"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              COLOR
              {/* <span className="required"> * </span> */}
              <Form.Control
                type="text"
                name="color"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              SIZE
              {/* <span className="required"> * </span> */}
              <Form.Control
                type="text"
                name="size"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={4}>
              BARCODE
              {/* <span className="required"> * </span> */}
              <Form.Control
                type="text"
                name="barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              {/* <InputError
                isValid={isError.barcode}
                message={"Barcode is required"}
              /> */}
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              INHOUSE BARCODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="inhouse_barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.inhouse_barcode}
                message={"Inhouse barcode is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              SERIAL NUMBER
              <Form.Control
                type="text"
                name="serial_number"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={4}>
              TAG
              {/* <span className="required"> * </span> */}
              <Form.Control
                type="text"
                name="tag"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              ITEM CODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="item_code"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              SALES TYPE
              <span className="required"> * </span>
              <select
                name="sales_type"
                className="ms-0 nc-modal-custom-select nc-modal-custom-input-edit "
                onChange={(e) => handleAddChange(e)}
              >
                <option hidden selected className="nc-modal-custom-select">
                  Select
                </option>
                <option value="wholesale"> Wholesale </option>
                <option value="retail"> Retail </option>
                <option value="universal"> Both </option>
              </select>
              <InputError
                isValid={isError.sales_type}
                message={"Sales type is required"}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            {itemDetails.category.map((data, index) => {
              return (
                <Col xs={12} lg={4}>
                  {index === 0 ? "CATEGORY" : "SUB-CATEGORY"}
                  <span className="required"> * </span>
                  <Row className="align-middle">
                    <Col xs={10}>
                      <Select
                        name="subcategories"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select..."
                        value={data}
                        options={
                          index === 0
                            ? categories
                            : itemDetails.category_options[index]
                        }
                        // options={filteredSubCategoriesi}
                        onChange={(e) =>
                          handleSelectDropdownChange(e, "add", index)
                        }
                      />
                      <InputError
                        isValid={isError.category}
                        message={"Category is required"}
                      />
                    </Col>
                    {index !== 0 && (
                      <Col xs={2}>
                        <img
                          src={trash}
                          alt="delete"
                          onClick={() => handleRemoveSubcategory(index, "add")}
                          className="cursor-pointer mt-2"
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
              )
            })}
          </Row>
          <Row></Row>
        </div>
      </AddModal>
      <AddModal
        title={`UNIT OF MEASURE CONVERSION`}
        type="item"
        show={showAddConversionModal}
        // onHide={handleCloseAddConversionModal}
        onSave={handleAddConversion}
        isClicked={isClicked}
        isCancel={true}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mb-0">
            <Col>UNIT OF MEASURE CONVERSION</Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <div className="edit-purchased-items justify-content-center">
              <div className="not-found mt-0 ">
                {itemsUnits.length === 0 ? (
                  <span> No unit of measure conversion found! </span>
                ) : (
                  renderTable()
                )}
              </div>
            </div>
          </Row>
        </div>
      </AddModal>
      <AddModal
        title={`ITEM PRICE`}
        type="item"
        size="xl"
        show={showAddItemPriceModal}
        onHide={handleCloseAddItemPriceModal}
        onSave={handleSaveItemPrice}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={12} lg={6}>
              ITEM NAME
              <Form.Control
                type="text"
                name="name"
                value={itemDetails.name}
                className="nc-modal-custom-input"
                disabled
              />
            </Col>
          </Row>
          <hr />
          {priceLevelDetails?.map((data, key) => {
            return (
              <>
                <Row className="nc-modal-custom-row mt-3">
                  <Col xs={8} lg={9}>
                    PRICE LEVEL
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select item..."
                      value={data.price_level_id_value}
                      options={filteredPriceLevel}
                      onChange={(e) =>
                        handlePriceLevelChange(e, "price_level", key)
                      }
                      isDisabled={filteredPriceLevel.length > 0 ? false : true}
                    />
                  </Col>
                  <Col xs={4} lg={3} className="mt-2 mt-lg-0 pt-3 PO-add-item">
                    <Button
                      type="button"
                      onClick={() => handleRemovePriceLevel(key)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                {data?.map((item, index) => {
                  return (
                    <>
                      <Row key={index} className="nc-modal-custom-row mt-3">
                        <Col xs={12} lg={2} className="unit">
                          {item.unit_from}
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          COST
                          <Form.Control
                            type="number"
                            name="cost_price"
                            value={item.cost_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            disabled={
                              parseFloat(item.original_cost_price) === 0
                                ? false
                                : true
                            }
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          MARGIN %
                          <Form.Control
                            type="number"
                            name="margin"
                            value={item.margin}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          SELLING PRICE
                          <Form.Control
                            type="number"
                            name="selling_price"
                            value={item.selling_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          WS PRICE
                          <Form.Control
                            type="number"
                            name="wholesale_price"
                            value={item.wholesale_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          RETAIL PRICE
                          <Form.Control
                            type="number"
                            name="retail_price"
                            value={item.retail_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                      </Row>
                      <Row key={index} className="nc-modal-custom-row mt-1">
                        <Col xs={12} lg={2}>
                          SPEC. PRICE 1
                          <Form.Control
                            type="number"
                            name="special_price_1"
                            value={item.special_price_1}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          SPEC. PRICE 2
                          <Form.Control
                            type="number"
                            name="special_price_2"
                            value={item.special_price_2}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          SPEC. PRICE 3
                          <Form.Control
                            type="number"
                            name="special_price_3"
                            value={item.special_price_3}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          VAT IN
                          <Form.Control
                            type="text"
                            name="vat_in"
                            value={
                              item.vat_in ? numberFormat(item.vat_in) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          VAT EX
                          <Form.Control
                            type="text"
                            name="vat_ex"
                            value={
                              item.vat_ex ? numberFormat(item.vat_ex) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                          VAT COMPONENT
                          <Form.Control
                            type="text"
                            name="vat_component"
                            value={
                              item.vat_component
                                ? numberFormat(item.vat_component)
                                : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                      </Row>
                    </>
                  )
                })}
                <hr />
              </>
            )
          })}
          <Row className="pt-3 PO-add-item">
            <Button
              type="button"
              disabled={filteredPriceLevel.length > 0 ? false : true}
              onClick={() => handleAddPriceLevel()}
            >
              Add Price Level
            </Button>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="ITEM"
        type="item"
        show={showEditItemModal}
        onHide={handleCloseEditItemModal}
        onSave={handleEditItem}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          {showEditLoader ? (
            <>
              <div className="d-flex justify-content-center my-5 mt-5 pt-5">
                <SyncLoader color="var(--primary-color)" size={15} />
              </div>
            </>
          ) : (
            <>
              <Row className="nc-modal-custom-row mt-0">
                <span className="custom-modal-body-title-employee mb-3">
                  ITEM DESCRIPTION
                </span>
                <Col xs={12} lg={4}>
                  ITEM NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="name"
                    defaultValue={itemData.name}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.name}
                    message={"Item name is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  BRAND
                  <Typeahead
                    id="basic-typeahead-single"
                    name="value"
                    labelKey="value"
                    allowNew
                    className="nc-modal-custom-text"
                    onChange={(e) => handleTypeaheadChange(e, "brand", "edit")}
                    options={brand}
                    placeholder="Select/type a brand..."
                    selected={itemData.selected_brand}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  MODEL
                  {/* <span className="required"> * </span> */}
                  <Form.Control
                    type="text"
                    name="model"
                    className="nc-modal-custom-input"
                    value={itemData.model}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
              </Row>
              <Row className="nc-modal-custom-row mt-3">
                <Col xs={12} lg={4}>
                  MATERIAL
                  <Form.Control
                    type="text"
                    name="material"
                    className="nc-modal-custom-input"
                    value={itemData.material}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  COLOR
                  {/* <span className="required"> * </span> */}
                  <Form.Control
                    type="text"
                    name="color"
                    className="nc-modal-custom-input"
                    value={itemData.color}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  SIZE
                  {/* <span className="required"> * </span> */}
                  <Form.Control
                    type="text"
                    name="size"
                    className="nc-modal-custom-input"
                    value={itemData.size}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
              </Row>
              <hr />
              <Row className="nc-modal-custom-row mt-3">
                <Col xs={12} lg={4}>
                  BARCODE
                  {/* <span className="required"> * </span> */}
                  <Form.Control
                    type="text"
                    name="barcode"
                    className="nc-modal-custom-input"
                    value={itemData.barcode}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                  {/* <InputError
                      isValid={isError.barcode}
                      message={"Barcode is required"}
                    /> */}
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  INHOUSE BARCODE
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="inhouse_barcode"
                    className="nc-modal-custom-input"
                    value={itemData.inhouse_barcode}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.inhouse_barcode}
                    message={"Inhouse barcode is required"}
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  SERIAL NUMBER
                  <Form.Control
                    type="text"
                    name="serial_number"
                    className="nc-modal-custom-input"
                    value={itemData.serial_number}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
              </Row>
              <Row className="nc-modal-custom-row mt-3">
                <Col xs={12} lg={4}>
                  TAG
                  {/* <span className="required"> * </span> */}
                  <Form.Control
                    type="text"
                    name="tag"
                    className="nc-modal-custom-input"
                    value={itemData.tag}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  ITEM CODE
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="item_code"
                    className="nc-modal-custom-input"
                    value={itemData.item_code}
                    onChange={(e) => handleEditChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                  SALES TYPE
                  <span className="required"> * </span>
                  <select
                    name="sales_type"
                    className="ms-0 nc-modal-custom-select nc-modal-custom-input-edit "
                    onChange={(e) => handleEditChange(e)}
                    value={itemData.sales_type}
                  >
                    <option hidden selected className="nc-modal-custom-select">
                      Select
                    </option>
                    <option value="wholesale"> Wholesale </option>
                    <option value="retail"> Retail </option>
                    <option value="universal"> Both </option>
                  </select>
                  <InputError
                    isValid={isError.sales_type}
                    message={"Sales type is required"}
                  />
                </Col>
              </Row>
              <Row className="nc-modal-custom-row mt-3">
                {itemData?.category?.map((data, index) => {
                  return (
                    <Col xs={12} lg={4}>
                      {index === 0 ? "CATEGORY" : "SUB-CATEGORY"}
                      <Row className="align-middle">
                        <Col xs={10}>
                          <Select
                            name="subcategories"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Select..."
                            value={data}
                            options={
                              index === 0
                                ? categories
                                : itemDetails.category_options[index]
                            }
                            // options={index === 0 ? categories : itemData?.category_options[index]}
                            // options={filteredSubCategories}
                            onChange={(e) =>
                              handleSelectDropdownChange(e, "edit", index)
                            }
                          />
                          <InputError
                            isValid={isError.category}
                            message={"Category is required"}
                          />
                        </Col>
                        {index !== 0 && (
                          <Col xs={2}>
                            <img
                              src={trash}
                              alt="delete"
                              onClick={() =>
                                handleRemoveSubcategory(index, "edit")
                              }
                              className="cursor-pointer mt-2"
                            />
                          </Col>
                        )}
                      </Row>
                    </Col>
                  )
                })}
              </Row>
              <Row className="nc-modal-custom-row mt-3 mb-0">
                <Col>UNIT OF MEASURE CONVERSION</Col>
              </Row>
              <Row>
                <div className="edit-purchased-items justify-content-center">
                  <div className="not-found mt-0 ">
                    {itemsUnits.length === 0 ? (
                      <span> No Unit of Measure Conversion Found! </span>
                    ) : (
                      editTable()
                    )}
                  </div>
                </div>
              </Row>
            </>
          )}
        </div>
      </EditModal>
      <EditModal
        title="UNIT OF MEASURE CONVERSION"
        type="item"
        show={showEditConversionModal}
        onHide={handleCloseEditConversionModal}
        onSave={handleEditConversion}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mb-0">
            <Col>UNIT OF MEASURE CONVERSION</Col>
          </Row>
          <Row>
            <div className="edit-purchased-items justify-content-center">
              <div className="not-found mt-0 ">
                {itemsUnits.length === 0 ? (
                  <span> No Unit of Measure Conversion Found! </span>
                ) : (
                  editTable()
                )}
              </div>
            </div>
          </Row>
          <Row className="pt-3 PO-add-item">
            <Button type="button" onClick={() => AddItemEdit()}>
              Add
            </Button>
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withHeader
        title="ITEM"
        withButtons
        show={showViewItemModal}
        onHide={handleCloseViewItemModal}
        withOutEdit={true}
        // onEdit={handleOnEdit}
      >
        <div className="mt-3 ">
          <div className="col-sm-12  space mt-0">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DESCRIPTION
            </span>
            <div className="container-wrapper mt-0">
              <Row className="nc-modal-custom-row-view mt-0">
                <Col xs={6} lg={4}>
                  ITEM NAME
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.name} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4}>
                  BRAND
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.brand_name} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="mt-3 mt-lg-0">
                  MODEL
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.model} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col xs={6} lg={4}>
                  MATERIAL
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.material} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4}>
                  COLOR
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.color} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="mt-3 mt-lg-0">
                  SIZE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.size} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div className="container-wrapper mt-3">
              <Row className="nc-modal-custom-row-view mt-3">
                <Col xs={6} lg={4}>
                  BARCODE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.barcode} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4}>
                  INHOUSE BARCODE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.inhouse_barcode} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="mt-3 mt-lg-0">
                  SERIAL NUMBER
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.serial_number} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                <Col xs={6} lg={4}>
                  TAG
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.tag} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4}>
                  ITEM CODE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.item_code} </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="mt-3 mt-lg-0">
                  SALES TYPE
                  <Row className="nc-modal-custom-row text-capitalize">
                    <Col> {itemData.sales_type} </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-3">
                {itemData?.category?.map((data, index) => {
                  return (
                    <Col xs={6} lg={4}>
                      {index === 0 ? "CATEGORY" : "SUB-CATEGORY"}
                      <Row className="nc-modal-custom-row text-capitalize">
                        <Col> {data.value} </Col>
                      </Row>
                    </Col>
                  )
                })}
              </Row>
            </div>
          </div>
          <Row className="nc-modal-custom-row mb-0 mt-3">
            <Col>UNIT OF MEASURE CONVERSION</Col>
          </Row>
          <div className="container-wrapper mt-0">
            <div className="edit-purchased-items justify-content-center">
              <div className="not-found">
                {itemsUnitsMap.length === 0 ? (
                  <span> No Unit of Measure Conversion Found! </span>
                ) : (
                  viewTable()
                )}
              </div>
            </div>
          </div>
        </div>
      </ViewModal>
      <Footer />
    </div>
  )
}
